import { jsx as _jsx } from "react/jsx-runtime";
import * as React from 'react';
import { DayPicker } from 'react-day-picker';
import 'react-day-picker/dist/style.css';
import { cn } from '../lib/cn.js';
/**
 * Themed wrapper around `react-day-picker`'s `DayPicker`. Applies the admin
 * theme tokens via `classNames` so callers get consistent styling whether
 * they embed the calendar inline or inside a popover. Extracted so
 * `DateRangePicker` and the inbox "Filters" popover can share one source of
 * truth for calendar theming.
 */
export const THEMED_CALENDAR_CLASS_NAMES = {
    root: 'rdp-root',
    months: 'flex flex-col sm:flex-row gap-4',
    month: 'space-y-2',
    month_caption: 'flex items-center justify-center h-8 text-sm font-medium',
    caption_label: 'text-sm font-medium text-[var(--color-text-primary)]',
    nav: 'flex items-center gap-1',
    button_previous: 'inline-flex h-7 w-7 items-center justify-center rounded-[var(--radius-2)] hover:bg-[var(--color-surface-sunken)] text-[var(--color-text-secondary)]',
    button_next: 'inline-flex h-7 w-7 items-center justify-center rounded-[var(--radius-2)] hover:bg-[var(--color-surface-sunken)] text-[var(--color-text-secondary)]',
    month_grid: 'w-full border-collapse',
    weekdays: 'flex',
    weekday: 'w-9 text-xs font-normal text-[var(--color-text-muted)] text-center',
    week: 'flex w-full mt-1',
    day: 'relative h-9 w-9 p-0 text-center text-sm',
    day_button: 'inline-flex h-9 w-9 items-center justify-center rounded-[var(--radius-2)] text-[var(--color-text-primary)] hover:bg-[var(--color-surface-sunken)] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[var(--color-border-focus)] aria-selected:bg-[var(--color-brand-bg)] aria-selected:text-[var(--color-brand-fg)] disabled:opacity-40 disabled:pointer-events-none',
    today: 'font-semibold [&_button]:ring-1 [&_button]:ring-inset [&_button]:ring-[var(--color-border-strong)]',
    selected: '',
    range_start: '[&_button]:bg-[var(--color-brand-bg)] [&_button]:text-[var(--color-brand-fg)] [&_button]:rounded-r-none',
    range_end: '[&_button]:bg-[var(--color-brand-bg)] [&_button]:text-[var(--color-brand-fg)] [&_button]:rounded-l-none',
    range_middle: '[&_button]:bg-[var(--color-surface-sunken)] [&_button]:text-[var(--color-text-primary)] [&_button]:rounded-none',
    outside: 'text-[var(--color-text-disabled)]',
    disabled: 'opacity-40',
    hidden: 'invisible',
};
export const Calendar = React.forwardRef(({ className, classNames, showOutsideDays = true, ...props }, ref) => {
    return (_jsx("div", { ref: ref, className: cn('p-3', className), children: _jsx(DayPicker, { showOutsideDays: showOutsideDays, classNames: { ...THEMED_CALENDAR_CLASS_NAMES, ...classNames }, ...props }) }));
});
Calendar.displayName = 'Calendar';
//# sourceMappingURL=calendar.js.map